import { Button } from '$components'
import { useEditServiceInfoForm } from './index'

export function EditServiceInfoControls() {
  const { onCancel, isLoading } = useEditServiceInfoForm()

  return (
    <div className="flex gap-stack-roomy mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Save Changes
      </Button>
    </div>
  )
}
